import { FETCH_LEAD_STATUS_FAILURE, FETCH_LEAD_STATUS_REQUEST, FETCH_LEAD_STATUS_SUCCESS } from "./actionType";

// reducer.js
const initialState = {
    statusOptions: [],
    loading: false,
    error: null
  };
  
  export const leadStatusReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_LEAD_STATUS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_LEAD_STATUS_SUCCESS:
        return {
          ...state,
          loading: false,
          statusOptions: action.payload,
          error: null
        };
      
      case FETCH_LEAD_STATUS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      default:
        return state;
    }
  };